// client/src/components/AboutUs/AboutUs.js
import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    // id="about" matches the navbar link
    <section id="about" className="section about-section">
      <div className="about-column">
        <h2>About OM Nidhi Production</h2>
        <p>
          OM Nidhi Production is a visionary film and media company dedicated
          to creating meaningful, inspiring, and high-quality visual content.
          Founded with the spirit of creativity and the essence of divinity,
          the name “OM Nidhi” symbolizes the harmony between art, culture, and
          storytelling.
        </p>
        <p>
          From concept to camera, we specialize in film production, music
          videos, ad films, digital campaigns, and creative media solutions.
          Our team of passionate filmmakers, actors, editors, and creative

          professionals work together to craft stories that move hearts and
          minds.
        </p>
        <p>
          We believe that every frame carries energy — and through our
          productions, we aim to reflect truth, emotion, and artistic
          excellence that resonates across generations.
        </p>
        <p>
          At OM Nidhi Production, we don’t just produce visuals — we create
          legacies, one story at a time.
        </p>
      </div>
      <div className="vision-column">
        <h3>🌟 Our Vision</h3>
        <p>
          To become a leading name in Indian entertainment and advertising,
          blending creativity, and professionalism to deliver cinematic
          experiences that inspire and uplift audiences worldwide.
        </p>
      </div>
    </section>
  );
};

export default AboutUs;